import { createMakeStyles } from 'tss-react';
import { useTheme } from '@material-ui/core';

const { makeStyles } = createMakeStyles({ useTheme });

export const useStyles = makeStyles()({
  header: {
    marginBottom: '1rem',

    '> div': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '0.5rem',
      
      '> div': {
        marginBottom: 0,
      },
    }
  },

  reportAndSupportButtonGroup: {
    display: 'flex',
    whiteSpace: 'noWrap'
  },
});


